export const FLT = 'flt'
export const MMB = 'mmb'
export const CKI = 'cki'

export const ripTypes = [FLT, MMB, CKI] as const
